import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axiosInstance from '@/api/axios';
import { useLoading } from '@/contexts/LoadingContext';
import axios from 'axios';
import RedirectIcon from "@/assets/RedirectIcon.svg"

const RedirectPage = () => {
  const { token } = useParams();
  const { setLoading } = useLoading();
  const [errorTitle, setErrorTitle] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;

    const redirectCall = async () => {
      try {
        setLoading(true);
        console.log('Redirect token:', token);

        const response = await axiosInstance.post(
          '/odoo/api/v1/redirectUrl',
          { secret: token },
          {
            headers: {
              'basic-auth-only': 'true',
            },
          }
        );

        const redirectUrl = response.data?.data?.redirectionUrl;
        const statusCode = response.data?.statusCode;

        if (statusCode === 200 && redirectUrl) {
          console.log('Redirecting to:', redirectUrl);
          window.location.href = redirectUrl;
        } else {
          console.error('Unexpected response structure:', response.data);
          setErrorTitle(response.data?.title || 'Something went wrong');
        }
      } catch (error) {
        console.error('Error during redirect:', error);

if (axios.isAxiosError(error)) {
  const status = error.response?.status;
  if (status && status >= 400 && status < 500) {
    setErrorTitle(error.response?.data?.title || 'The link has expired. Please request a new one.');
    return;
  }
}
setErrorTitle('Unexpected error occurred.');

      } finally {
        setLoading(false);
      }
    };

    redirectCall();
  }, [token, setLoading]);

  return (
    <div>
      {errorTitle &&( 
        <div className='flex flex-col items-center justify-center h-screen space-y-4'>
        <img src={RedirectIcon} alt="Card Break" />
        <h1 className='text-[24px] w-[70%] md:w-[35%] xl:w-[25%] 2xl:w-[18%]  mx-auto text-center text-[#363636]'>{errorTitle}</h1>
        </div>
    )}

    </div>
  );
};

export default RedirectPage;
